let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fqE7m")).then(() => parcelRequire('5qJOA'));